import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import {
  nutritionistTestCurrentStepSelector,
  nutritionistTestOptionsSelector,
  nutritionistTestTargetSelector,
} from 'features/nutritionists/selectors/nutritionist-test.selector';
import { setNutritionistTestCurrentStep } from 'features/nutritionists/state/nutritionist-test.slice';

import { useStyles } from './nutritionist-search-test-step-2-form.styles';

export const NutritionistSearchTestStep2Form = () => {
  const [questionValue, setQuestionValue] = useState('');

  const step = useSelector(nutritionistTestCurrentStepSelector);

  const target = useSelector(nutritionistTestTargetSelector);

  const { step2: questionOptions } = useSelector(
    nutritionistTestOptionsSelector,
  );

  const dispatch = useDispatch();

  const classes = useStyles();

  const onSelectChangeHandler = event => {
    const { value: questionValue } = event.target;
    setQuestionValue(questionValue);
  };

  const onNextStepHandler = () => {
    const target = questionOptions.find(option => option.key === questionValue);
    console.log('question value: ', target);
  };

  const onPreviousStepHandler = () => {
    dispatch(setNutritionistTestCurrentStep(step - 1));
  };

  return (
    <Box component="section" className={classes.stack}>
      <Typography variant="h6">¿Qué objetivo tienes en mente?</Typography>
      <Typography variant="body2" className={classes.capitalize}>
        {target.option}
      </Typography>
      <FormControl style={{ width: '33.3%' }} variant="outlined">
        <InputLabel>Selecciona una opción</InputLabel>
        <Select
          label="Selecciona una opción"
          value={questionValue}
          onChange={onSelectChangeHandler}
        >
          {target.childOptions.map(option => (
            <MenuItem key={nanoid()} value={option.key}>
              {option.option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box className={classes.buttonsWrapper}>
        <Button
          variant="outlined"
          color="primary"
          onClick={onPreviousStepHandler}
        >
          Anterior
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={onNextStepHandler}
          disabled={!questionValue}
        >
          Siguiente
        </Button>
      </Box>
    </Box>
  );
};
